<template>
  <div class="cadfm-container-horizontal">
    <!-- <Left  v-show="isVisibleLeft && !isPlugin" :lang="lang.Left"></Left> -->
    <Left  v-show="isVisibleLeft" :lang="lang.Left"></Left>
    <Middle  :lang="lang.Middle"></Middle>
    <!--<Right></Right>-->
  </div>
</template>

<script>
import Left from '@/components/PartManager/Views/PartNew/Left/Left'
import Middle from '@/components/PartManager/Views/PartNew/Middle/Middle'
//import Right from '@/components/PartManager/Views/PartNew/Right/Right'
import { mapGetters } from 'vuex'


export default {
  name: 'PartNew',
  components:{
    Left,
    Middle,
    //Right
  },
  data () {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    }
  },
 props:{
    
    lang: Object
  },
  computed: {
    ...mapGetters([
      'isPlugin',
      
    ]),

  },
  
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartNew.vue